import axiosInstance from "../app/axios";

export const getUsersExcel = async () => {
  const result = await axiosInstance.get(`admin/users/information/excel`);
  return result.data.file;
};

export const getUserById = async (userId: number) => {
  const result = await axiosInstance.get(`admin/users/${userId}`);
  return result.data;
};
